import type {NavigationAction} from 'src/action-creators/navigation';

import {TOGGLE_SIDE_NAV} from 'src/action-creators/navigation';


export type NavigationState = {
  sideNavHidden: boolean;
};

const initialState = {
  sideNavHidden: false,
} as const;

export default (
  state: NavigationState | null | undefined = initialState,
  action: NavigationAction,
): NavigationState => {
  switch (action.type) {
    case TOGGLE_SIDE_NAV: {
      return {
        ...state,
        sideNavHidden: action.payload.hide,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'NavigationState | null' is not assignable to type 'NavigationState'.
  return state;
};
